import { render, staticRenderFns } from "./Tab3_2Treatment_etc.vue?vue&type=template&id=a48ffbf8&scoped=true&"
import script from "./Tab3_2Treatment_etc.vue?vue&type=script&lang=js&"
export * from "./Tab3_2Treatment_etc.vue?vue&type=script&lang=js&"
import style0 from "./Tab3_2Treatment_etc.vue?vue&type=style&index=0&id=a48ffbf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48ffbf8",
  null
  
)

export default component.exports